import { createFileRoute, redirect } from '@tanstack/react-router';

/* L'andamento WBS sta fra i Progetti: qui restano i vecchi segnalibri. */
export const Route = createFileRoute('/_app/tasks/wbs')({
  beforeLoad: ({ search }) => {
    const project = (search as { project?: unknown }).project;
    throw redirect({
      to: '/projects/wbs',
      search: typeof project === 'string' && project ? { project } : {},
      replace: true,
    });
  },
});
